import React, { useEffect, useRef, useState } from "react";
import * as faceapi from "face-api.js";
import "./faceattendance.css";
import { getUsers, getAttendance } from "./utils";
import { Link } from "react-router-dom";

import RegisterFace from "./RegisterFace";
import MarkAttendance from "./MarkAttendance";

const FaceAttendance = () => {
  const videoRef = useRef(null);

  const [users, setUsers] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [activeTab, setActiveTab] = useState("markattendance");

  // Load Models
  useEffect(() => {
    const loadModels = async () => {
      const MODEL_URL = "/models";

      await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
      await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
      await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);

      startVideo();
    };

    loadModels();
    refreshUsers();
    refreshAttendance();
  }, []);

  const refreshUsers = () => {
    setUsers(getUsers());
  };

  const refreshAttendance = () => {
    setAttendance(getAttendance());
  };

  const startVideo = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      alert("Camera access denied ❌");
    }
  };

  return (
    <div className="facetracker">
      <h2>Face Attendance</h2>

      <div className="faceheader-icon">
        {activeTab === "markattendance" && (
          <button onClick={() => setActiveTab("register")}>➕</button>
        )}

        {activeTab === "register" && (
          <button onClick={() => setActiveTab("markattendance")}>📌</button>
        )}

        <Link to="attendance">
          <button>📋</button>
        </Link>
      </div>

      <video ref={videoRef} autoPlay muted playsInline className="video" style={{ transform: "scaleX(-1)" }}/>

      {/* Components */}
      {activeTab === "register" && (
        <RegisterFace
          videoRef={videoRef}
          refreshUsers={refreshUsers}
        />
      )}

      {activeTab === "markattendance" && (
        <MarkAttendance
          videoRef={videoRef}
          users={users}
          refreshAttendance={refreshAttendance}
        />
      )}
    </div>
  );
};

export default FaceAttendance;